/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1ExclusionAddresses } from '../models/V1ExclusionAddresses';
import { HttpFile } from '../http/http';

/**
* Response payload listing an org's exclusion-address files
*/
export class V1ListExclusionAddressesResponse {
    'exclusionAddresses'?: Array<V1ExclusionAddresses>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "exclusionAddresses",
            "baseName": "exclusion_addresses",
            "type": "Array<V1ExclusionAddresses>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1ListExclusionAddressesResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

